module.exports = __webpack_public_path__ + "static/media/3@2x.45feabbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_150/img/3@2x.png
// module id = 1475
// module chunks = 0